import { useEffect, useState } from "react";
import TabButtonsList from "./TabButtonsList";
import TabsSection from "./TabsSection";

const TabsSectionBox = ({ doctor }) => {
  const [activeTab, setActiveTab] = useState("about");

  const sections = [
    {
      key: "about",
      title: "درباره‌ی",
      content: (
        <div className="leading-8 text-gray-700 text-justify">
          {doctor.description || "توضیحی برای این پزشک ثبت نشده است."}
        </div>
      ),
    },
    {
      key: "services",
      title: "خدمات",
      content: (
        <div className="space-y-3">
          {doctor.service_list && doctor.service_list.length > 0 ? (
            <ul className="list-disc pr-4 space-y-2">
              {[...new Set(doctor.service_list.map((s) => s.type))].map(
                (type, index) => (
                  <li key={index} className="text-gray-700">
                    {type === "appointment"
                      ? "ویزیت حضوری"
                      : type === "online_visit"
                        ? "ویزیت آنلاین"
                        : type}
                  </li>
                ),
              )}
            </ul>
          ) : (
            <p className="text-gray-700">هیچ خدمتی ثبت نشده است.</p>
          )}
        </div>
      ),
    },
    {
      key: "specialities",
      title: "تخصص‌های",
      content: (
        <div className="space-y-3">
          {doctor.speciality_list && doctor.speciality_list.length > 0 ? (
            <ul className="list-disc pr-4 space-y-2">
              {doctor.speciality_list.map((item) => (
                <li key={item.id} className="text-gray-700">
                  {item.title === "NaN" ? "خدمتی ثبت نشده است" : item.title}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-700">تخصصی ثبت نشده است.</p>
          )}
        </div>
      ),
    },
    {
      key: "contact",
      title: "اطلاعات تماس",
      content: (
        <div className="text-gray-700 leading-8">
          {/* نمونه - بسته به دیتای doctor تغییرش بده */}
          <p>شماره تماس: {doctor.phone || "ثبت نشده"}</p>
          <p>آدرس: {doctor.address || "ثبت نشده"}</p>
        </div>
      ),
    },
  ];

  // 🔹 اسکرول نرم هنگام کلیک روی دکمه
  const handleScrollTo = (id) => {
    const el = document.getElementById(id);
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // 🔹 تشخیص تب فعال در هنگام اسکرول
  useEffect(() => {
    const handleScroll = () => {
      let current = activeTab;
      sections.forEach((section) => {
        const el = document.getElementById(section.key);
        if (el) {
          const offset = el.offsetTop - 150;
          if (window.scrollY >= offset) {
            current = section.key;
          }
        }
      });
      setActiveTab(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeTab]);

  return (
    <div className="">
      {/* 🔸 نوار دکمه‌ها */}
      <TabButtonsList
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onScrollTo={handleScrollTo}
      />

      {/* 🔸 بخش‌های محتوا */}
      <div className="flex flex-col gap-5 mb-5 mt-5">
        {sections.map((section) => (
          <div id={section.key} key={section.key} className="scroll-mt-24">
            <TabsSection
              title={section.title}
              name={doctor.name}
              desc={section.content}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabsSectionBox;
